import React from 'react';
import { useTranslator } from 'static/script/app/lang';

const GdprSiteFooterComponent = ({ action }) => {
    const { t } = useTranslator();
    return (
        <a
            className="cursor-pointer"
            data-ga-category="Footer"
            data-ga-action="Navigation"
            data-ga-label="Open GDPR Settings"
            onClick={action}>
            {t('footer_gdpr_settings')}
        </a>
    );
};

export default GdprSiteFooterComponent;
